module.exports = __webpack_public_path__ + "assets/img/logo-taiwan-travel.3cba570e.png";